import {
  FETCH_MENUS_REQUEST,
  FETCH_MENUS_SUCCESS,
  FETCH_MENUS_ERROR,
  ACCESS_MENUS_REQUEST,
  ACCESS_MENUS_SUCCESS,
  ACCESS_MENUS_ERROR,
  CHANGE_MENU_ITEM_SELECTION,
  FETCH_PERMISSIONS_REQUEST,
  FETCH_PERMISSIONS_SUCCESS,
  FETCH_PERMISSIONS_ERROR,
  FETCH_NEW_HOME_MENUS_FILTER_REQUEST,
  FETCH_NEW_HOME_MENUS_FILTER_SUCCESS,
  FETCH_NEW_HOME_MENUS_FILTER_FAILURE,
} from 'actionTypes'

const defaultState = {
  menu: {},
  isFetching: false,
  error: null,
  selectedMenu: {},
  permissions: [],
}

const menu = (state = defaultState, action) => {
  switch (action.type) {
    case FETCH_MENUS_REQUEST:
    case ACCESS_MENUS_REQUEST:
    case FETCH_PERMISSIONS_REQUEST:
      return {
        ...state,
        isFetching: true,
      }

    case FETCH_MENUS_SUCCESS:
      return {
        ...state,
        menu: action.payload,
        isFetching: false,
        error: null,
      }

    case FETCH_MENUS_ERROR:
      return {
        ...state,
        menu: {},
        isFetching: false,
        error: action.payload,
      }

    case ACCESS_MENUS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: null,
      }

    case ACCESS_MENUS_ERROR:
    case FETCH_PERMISSIONS_ERROR:
      return {
        ...state,
        isFetching: false,
        error: action.payload,
      }

    case CHANGE_MENU_ITEM_SELECTION:
      return {
        ...state,
        selectedMenu: action.payload,
      }

    case FETCH_PERMISSIONS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        permissions: action.payload,
      }

    case FETCH_NEW_HOME_MENUS_FILTER_REQUEST:
      return {
        ...state,
        menuFiltersLoading: true,
      }

    case FETCH_NEW_HOME_MENUS_FILTER_SUCCESS:
      return {
        ...state,
        menuFiltersLoading: false,
        menuFilters: action.payload,
      }

    case FETCH_NEW_HOME_MENUS_FILTER_FAILURE:
      return {
        ...state,
        menuFiltersLoading: false,
        menuFilters: { error: true },
      }

    default:
      return state
  }
}

export default menu
